import { fetchAsyncData } from 'components.modules.gen/placeholder-dataurl/fetchDataAsync.js';
import { IAdTarget, IAdvertisingConfigRaw } from 'redux-state/advertisement/types.js';
import { IPrimarySlotConfigResponse } from 'redux-state/layout/types.layout.js';
import { IPageConfig } from 'redux-state/layout/types.page.js';
import { getTargetedAdsUrl } from 'routing/utils/ad-targeting-url.js';
import { objectAssignTypeSafety } from 'utilities/helpers/objects.js';
import { setTagsInit } from '../../page/set-tags.js';
import { applySiteOverideTargetting } from './ad-targeting-merge.js';
import { mergeMcpData as jsonMergeMCP } from './json-merge-mcp.js';

export interface IConfigs {
  pageJson: IPageConfig;
  overlay?: IPageConfig;
}

const getPrimaryDataUrl = async (primary: IPageConfig<'Raw'>['layout']['primary']) => {
  const path = primary?.dataUrl;
  if (path) {
    // console.log('Requesting Primary Data');
    const result = await fetchAsyncData<IPrimarySlotConfigResponse>({ url: path });
    if (result.responseOK) {
      // console.log('We got some primary data woohoo');
      const mergedPrimary = objectAssignTypeSafety(primary, result.jsonData);
      // const mergedLayout = objectAssignTypeSafety(pageJson.layout, { primary: mergedPrimary });
      // const mergedPageJson = objectAssignTypeSafety(pageJson, { layout: mergedLayout });
      return mergedPrimary;
    } else {
      console.error(`Unable to get primary data ${path}`);
      return primary;
    }
  }
  return primary;
};

const setTags = setTagsInit();

export const jsonMergeAdditional = async (pageJson: IPageConfig<'Raw'>): Promise<IPageConfig<'Raw'>> => {
  /** Creates data structure for config and load all modules in config */
  const promisePrimaryData = getPrimaryDataUrl(pageJson.layout.primary);
  const promiseAdsData = getTargetedAdsUrl(pageJson.advertising);

  const [resolvedPrimaryData, resolvedAdsData] = await Promise.all([promisePrimaryData, promiseAdsData]);
  const newAdsStatic = applySiteOverideTargetting(resolvedAdsData.targeting?.staticData ?? []);
  const newAdsTargeting: IAdTarget = {
    ...resolvedAdsData.targeting,
    ...{ staticData: newAdsStatic },
  };
  const newAds: IAdvertisingConfigRaw = {
    ...resolvedAdsData,
    ...{ targeting: newAdsTargeting },
  };

  const newLayout = { ...pageJson.layout, ...{ primary: resolvedPrimaryData } };
  const newPageJson: IPageConfig<'Raw'> = {
    ...pageJson,
    ...{ advertising: newAds, layout: newLayout },
  };

  const finalJson = await jsonMergeMCP(newPageJson);
  setTags(pageJson.metadata);
  return finalJson;
};
